export const whatIsBTSNodes = [
  {
    id: "186.1.43.90",
    type: "custom",
    position: { x: 40, y: 100 },
    className: "bts",
    data: { label: "186.1.43.90" },
    dragHandle: "noDrag",
  },
  {
    id: "69.131.176.185",
    type: "custom",
    position: { x: 375, y: 125 },
    className: "mobil",
    data: { label: "69.131.176.185" },
    dragHandle: "noDrag",
  },

  {
    id: "86.108.103.180",
    type: "gateway",
    position: { x: 25, y: 420 },
    className: "gateway",
    data: { label: "86.108.103.180" },
    dragHandle: "noDrag",
  },
  {
    id: "43.27.66.183",
    type: "custom",
    position: { x: 565, y: 420 },
    className: "server-plain",
    data: { label: "43.27.66.183" },
    dragHandle: "noDrag",
  },
];
